export const TASK_CATEGORY_OPTIONS = [
  { value: 'follow_up', label: 'Follow Up' },
  { value: 'call', label: 'Call' },
  { value: 'email', label: 'Email' },
  { value: 'sms_text', label: 'SMS Text' },
  { value: 'appointment', label: 'Appointment' },
  { value: 'onboarding', label: 'Onboarding' },
  { value: 'letter', label: 'Letter' },
  { value: 'social_media', label: 'Social Media' },
  { value: 'other', label: 'Other' },
];
